<!--我的页面-->
<template>
    <div class="id">
        <div class="navBar" @click="$router.back()">
            <van-icon name="arrow-left" />
            {{ $t('分享好友') }}
        </div>
        <div class="boxTop">
            <div class="universal">
                <van-field v-model="quantity" :label="$t('邀请码')" :border="false" />
                <div style="color: #07ecfe;white-space: nowrap;" @click="copyText(quantity)">{{ $t('复制') }}</div>
            </div>

            <div class="universal">
                <van-field v-model="shareUrl" :label="$t('邀请链接')" :border="false" />
                <div style="color: #07ecfe;white-space: nowrap;" @click="copyText(shareUrl)">{{ $t('复制') }}</div>
            </div>

            <div class="title">{{ $t('我的邀请') }}</div>
            <div class="myInvitation">
                <div class="item">
                    <div>{{ source.invite_number }}</div>
                    <div>{{ $t('邀请人数') }}</div>
                </div>
                <div class="item">
                    <div>{{ source.invite_reward }}</div>
                    <div>{{ $t('总返佣') }}</div>
                </div>
                <div class="item">
                    <div>{{ source.invite_today_reward }}</div>
                    <div>{{ $t('今日反佣') }}</div>
                </div>
                <div class="item">
                    <div>{{ source.invite_month_reward }}</div>
                    <div>{{ $t('本月反拥') }}</div>
                </div>
            </div>

            <!-- <van-button class="btn" type="primary">兑换</van-button> -->
        </div>

        <div style="font-size: 18px;padding-top: 30px;padding-bottom: 10px;">{{ $t('邀请记录') }}</div>

        <van-tabs v-model="active" @change="onChange" background="#000" title-active-color="#ffffff"
            title-inactive-color="#888" color="#dfdfdf">
            <van-tab v-for="(item, index) in source.user_count" :key="index" :title="item.title">
                <div class="table">
                    <!-- 表头 -->
                    <van-row class="header">
                        <van-col span="6" class="vanItem">{{ $t('帐户') }}</van-col>
                        <van-col span="6" class="vanItem">{{ $t('类型') }}</van-col>
                        <van-col span="6" class="vanItem">{{ $t('返佣金额') }}</van-col>
                        <van-col span="6" class="vanItem">{{ $t('时间') }}</van-col>
                    </van-row>
                    <!-- 数据 -->
                    <div class="scroll">
                        <van-row v-for="item in users" :key="item.id" class="row">
                            <van-col span="6" class="trade">
                                {{ item.username }}
                            </van-col>
                            <van-col span="6" class="trade">
                                {{ item.type }}
                            </van-col>
                            <van-col span="6" class="trade">
                                {{ item.money }}
                            </van-col>
                            <van-col span="6" class="trade">
                                {{ item.createtime }}
                            </van-col>
                        </van-row>
                    </div>
                </div>
            </van-tab>
        </van-tabs>


    </div>
</template>
<script>
import { get } from '@/http/request'
import apis from '@/http/api';
export default {
    components: {

    },
    data() {
        return {
            active: 1,
            quantity: '',
            shareUrl: '',
            users: [],
            source: {},
        };
    },
    mounted() {
        this.shareUrl = localStorage.getItem('shareUrl')
        this.quantity = this.shareUrl.split('=')[1].split('&')[0]
        this.getTeamData()
        this.getInviteList()
    },
    beforeUnmount() { },
    methods: {
        async getTeamData() {
            const res = await get(apis.getTeamData)
            if (res.code == 1) {
                console.log(res.data, '44444');
                this.source = res.data
                return
            }
        },
        async getInviteList() {
            const res = await get(apis.getInviteList, { limit: 999, level: this.active })
            if (res.code == 1) {
                console.log(res.data.list, '44444');
                this.users = res.data.list
                return
            }
        },

        onChange(name, title) {
            console.log("切换到", name, title)
            // this.getInviteList()
        },
        //复制
        copyText(text) {
            const input = document.createElement('input')
            input.value = text
            document.body.appendChild(input)
            input.select()
            document.execCommand('copy')  // 执行复制
            document.body.removeChild(input)
            this.$message.success(this.$t('复制成功')) // 如果有 element-ui
        }


    },
};
</script>
<style lang="less" scoped>
::v-deep .van-cell {
    padding: 0;
    background-color: #000;
}

::v-deep .van-tabs__wrap {
    border-bottom: 1px solid #20212a;
}

::v-deep .van-cell__value {
    margin-right: 10px;
}

::v-deep .van-field__label {
    width: auto;
}

.id {
    color: #fff;
    padding: 0 15px;
    padding-bottom: 20px;
    padding-top: 50px;
    font-size: 14px;

    .navBar {
        background-color: #1f1f2f;
        padding: 15px 10px;
        font-size: 18px;
        font-weight: 700;
        border-radius: 4px;
    }

    .boxTop {
        padding: 10px;
        border-radius: 10px;
        margin-top: 20px;
        background-color: #1f1f2f;
    }

    .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 20px;
        font-weight: 700;
    }

    .btn {
        width: 100%;
        margin: 10px 0;
        background-color: #07ecfe;
        border-radius: 10px;
        color: #000;
    }

    .table {
        color: #fff;
        font-size: 12px;
        background-color: #1c222c;
        margin-top: 20px;
        border-radius: 5px;

        .header {
            padding: 15px 0;
            border-bottom: 1px solid #272c38;
            font-size: 14px;
            font-weight: 700;

            .vanItem {
                text-align: center;
            }
        }

        .scroll {
            overflow-y: auto;
            height: 45vh;
            scrollbar-width: none;
            /* Firefox */
            -ms-overflow-style: none;
            color: #999999;
            /* IE/Edge */
        }

        .row {
            padding: 10px 0px;
            display: flex;
            align-items: center;
            font-size: 11px;

            .trade {
                text-align: center;
            }
        }
    }

    .myInvitation {
        padding: 20px;
        padding-bottom: 0;
        border-radius: 10px;
        margin-top: 10px;
        border: 1px solid #29293a;
        display: flex;
        flex-wrap: wrap;

        .item {
            width: 50%;
            text-align: center;
            margin-bottom: 20px;
            color: #888;

            div:nth-child(1) {
                padding-bottom: 10px;
                font-size: 20px;
                color: #fff;
            }
        }
    }


    .universal {
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;
        border-radius: 5px;
        background-color: #000;
    }

}
</style>
